import { render } from "./index.vue?vue&type=template&id=1930d87a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1930d87a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1930d87a"

export default script